// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GAuxThbeImMSlHKYHGL5{justify-content:center;align-items:center;height:100%;margin:0 20px 20px;display:flex}.Hc_sJR4DjX46uGSwuZF9{overflow-x:hidden;overflow-y:auto}.fKOJg1xfNg_gPWuQC0Q3{flex-direction:column;gap:20px;margin:0 20px 20px;display:flex}.JIELbvl2oUdZErkE8MIE{justify-content:space-between;align-items:center;min-height:64px;display:flex}.B6u4AzPkEYta3FOZ4pDs{border:1px solid var(--interaction-neutral-normal);cursor:pointer;border-radius:8px;align-items:center;display:flex}.B6u4AzPkEYta3FOZ4pDs:hover,.B6u4AzPkEYta3FOZ4pDs:hover>*{border-color:var(--interaction-neutral-hovered)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullPageContainer": `GAuxThbeImMSlHKYHGL5`,
	"container": `Hc_sJR4DjX46uGSwuZF9`,
	"sectionsContainer": `fKOJg1xfNg_gPWuQC0Q3`,
	"sectionHeader": `JIELbvl2oUdZErkE8MIE`,
	"metricsRow": `B6u4AzPkEYta3FOZ4pDs`
};
export default ___CSS_LOADER_EXPORT___;
